import React from 'react'
import moment from 'moment';
import { Button } from "reactstrap";

const InvestorViewCard = ({ investorData, detailsToggler = true }) => {
    const ordinal = (i) => {
        var j = i % 10,
            k = i % 100;
        if (j == 1 && k != 11) {
            return i + "st";
        }
        if (j == 2 && k != 12) {
            return i + "nd";
        }
        if (j == 3 && k != 13) {
            return i + "rd";
        }
        return i + "th";
    }
  return (
      <>
        <div className="card w-100 border-0 rounded-5 shadow p-3 p-sm-4 p-md-5 p-lg-4 p-xl-4">
            <div className="d-flex p-2 justify-content-between align-items-center mb-1 mt-1">
                  <h3><span className="base-font-600 fs-1 mb-0 text-decoration-none text-base-color ps-5">{ordinal(investorData?.ownership)} Owner:</span> <span className="fs-1 text-black mb-0 text-decoration-none ps-3">{investorData?.Investors?.name}</span></h3>
            </div>
            {detailsToggler && <div className="bg-white d-flex mb-5  flex-column border-radius-32"><hr/>
                <div className="row align-items-center justify-content-center py-3">
                    <div className="col-12 row py-3">
                        <div className="col-12 col-sm-5 mx-auto d-flex flex-column gap-4">
                            <h5 className="fs-3 title-font-800 text-base-black">Party Name :  <span className='fs-3 base-font-500 text-black'>{investorData?.Investors?.name}</span> </h5>
                            <h5 className="fs-3 title-font-800 text-base-black">Contact No :  <span className='fs-3 base-font-500 text-black'>{investorData?.Investors?.contact_number}</span> </h5>
                            <h5 className="fs-3 title-font-800 text-base-black">Sale on : <span className='fs-3 base-font-500 text-black'>{moment(investorData?.created_at).format('DD/MM/YYYY')}</span> </h5>
                            <h5 className="fs-3 title-font-800 text-base-black">Building No :  <span className='fs-3 base-font-500 text-black'>{investorData?.building?.building_no}</span> </h5>
                            <h5 className="fs-3 title-font-800 text-base-black">Gala No : <span className='fs-3 base-font-500 text-black'>{investorData?.gala?.gala_no}</span> </h5>
                            <h5 className="fs-3 title-font-800 text-base-black">Index No : <span className='fs-3 base-font-500 text-black'>{investorData?.index == "" ? "NA" : investorData.index}</span> </h5>
                        </div>
                        <div className="col-12 col-sm-5 mx-auto d-flex flex-column gap-4">
                            <h5 className="fs-3 title-font-800 text-base-black">Address : <span className='fs-3 base-font-500 text-black'>{investorData?.Investors?.address}</span> </h5>
                            <h5 className="fs-3 title-font-800 text-base-black">Owner Type : <span className='fs-3 base-font-500 text-black'>{investorData?.ownertype}</span> </h5>
                            <h5 className="fs-3 title-font-800 text-base-black">Sub Gala :  <span className='fs-3 base-font-500 text-black'>{investorData?.sub_gala_name}</span> </h5>
                            <h5 className="fs-3 title-font-800 text-base-black">Area : <span className='fs-3 base-font-500 text-black'>{investorData?.sold_gala_area - investorData?.resell_area} Sq.ft</span> </h5>
                            <h5 className="fs-3 title-font-800 text-base-black">Status : <span className='fs-3 base-font-500 text-black'>{ordinal(investorData?.ownership)} Owner</span> </h5>
                            {investorData?.ownership > 1 && <h5 className="fs-3 title-font-800 text-base-black">Reason for Resell : <span className='fs-3 base-font-500 text-black'>{investorData?.resell_reason}</span> </h5>}
                        </div>
                    </div>
                </div>
            </div>}
        </div>
    </>
  )
}

export default InvestorViewCard